import React from "react";
const DateRangeDisplay = ({ dateField, referenceStart, referenceEnd, currentStart, currentEnd }) => {
    let referencePeriod = "starting on " + referenceStart + " through " + referenceEnd;
    if (referenceEnd === currentStart) {
        referencePeriod = "starting on " + referenceStart + " ending before " + referenceEnd;
    }
    const currentPeriod = "starting on " + currentStart + " through " + currentEnd;
    return (React.createElement(React.Fragment, null, `Comparing the changes from the reference period (${referencePeriod}) to current period (${currentPeriod})`));
};
export default DateRangeDisplay;
